import React from 'react';
import { Menu } from '@mui/material';
import { Button } from './input';
import { FilterList } from '@mui/icons-material';
import { styled } from '@mui/styles';
import { StyleDivider } from './StyleDivider';

interface Props {
    readonly styled: StyledProps;
    readonly title: string;
    readonly menuElement: React.ReactNode;
    readonly onFilter: () => void;
    readonly onClose: () => void;
}

interface State {
    readonly anchorEl: HTMLElement | undefined;
}

export class SimpleFilter extends React.Component<Props, State> {
    state: State = {
        anchorEl: undefined,
    };

    render() {
        const { title, menuElement, onFilter } = this.props;
        const { anchorEl } = this.state;
        const handleMenu = (event: any) => this.setState({ anchorEl: event.currentTarget });
        const closeMenu = () => this.setState({ anchorEl: undefined });
        const onCancelButton = () => {
            closeMenu();
            this.props.onClose();
        };
        const onFilterButton = () => {
            closeMenu();
            onFilter();
        };

        const open = !!anchorEl;

        return (
            <>
                <Button
                    icon={FilterList}
                    iconSize={18}
                    text={title}
                    variant="contained"
                    onClick={handleMenu}
                    style={{
                        fontWeight: 600,
                        fontSize: 12,
                        borderRadius: 16,
                        height: 24,
                    }}
                />
                <MainMenu
                    id={`filter`}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    open={open}
                    style={{ padding: 0 }}
                    onClose={onCancelButton}
                >
                    <div style={{ display: 'flex' , minHeight: 100}}>
                        <div style={{ minWidth: 150, padding: '14px 0', display: 'flex', flexDirection: 'column'}}>
                            {menuElement}
                        </div>
                    </div>
                    <StyleDivider styled={this.props.styled}/>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 8, gridColumnGap: 10 }}>
                        <Button text="Cancel" variant="text" onClick={onCancelButton} />
                        <Button text="Apply" variant="contained" onClick={onFilterButton} />
                    </div>
                </MainMenu>
            </>
        );
    }
}

const MainMenu = styled(Menu)(({
    '& .MuiMenu-paper': {
        marginTop: 2,
        padding: 5,
    },
    '& .MuiMenu-list': {
        padding: 0,
    },
}));
